import { render, staticRenderFns } from "./ComTaskList.vue?vue&type=template&id=e31aa3ba&"
import script from "./ComTaskList.vue?vue&type=script&lang=js&"
export * from "./ComTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports